import { Box, Typography, useTheme } from "@mui/material"

export default function ModeButton({...params}){
    let theme = useTheme();

    let pageMode = params.pageMode
    let setPageMode = params.setPageMode

    let modeButtonState = params.modeButtonState
    let setModeButtonState = params.setModeButtonState

    const togglePageMode = () => {
        if (pageMode === 'read') setPageMode('edit')
        else if (pageMode === 'edit' || pageMode === 'schedule') setPageMode('read')
    }

    const handleButtonHover = (event) => {
        event.preventDefault()
        setModeButtonState('hover')
    }

    const handleButtonMouseOut = (event) => {
        event.preventDefault()
        setModeButtonState('default')
    }

    let buttonColor = ''
    let buttonText = 'Edit Mode'
    let modeButtonFontColor = theme.palette.ChannelPage.subheader.fontfilled

    if (pageMode === 'read'){
        if (modeButtonState === 'hover') buttonColor = '#108DF9'
        else if (modeButtonState === 'default') buttonColor = '#04569D'
    }
        
    else if (pageMode === 'edit') {
        if (modeButtonState === 'hover') buttonColor = theme.palette.ChannelPage.subheader.grayhighlight
        else if (modeButtonState === 'default') buttonColor = theme.palette.ChannelPage.subheader.gray
        buttonText = 'Exit'
        modeButtonFontColor = theme.palette.ChannelPage.subheader.fontdefault
    }

    return (
        <>
            {(pageMode === 'read' || pageMode === 'edit') && (
                <Box alignSelf={'center'} height={'35px'} width={'105px'} padding={'5px 10px'} sx={{backgroundColor: buttonColor}} 
                    onClick={togglePageMode}
                    onMouseOut={(event) => handleButtonMouseOut(event)} 
                    onMouseOver={(event) => handleButtonHover(event)}
                >
                    <Typography align={'center'} color={modeButtonFontColor} fontSize={'18px'} fontWeight={400}>{buttonText}</Typography>
                </Box>
            )}
        </>
    )
}
